import React from 'react'
import '../Services/Services.css'
import './Blog.css'

const BlogHero = () => {
  return (
    <div className="services-hero">
      <div className='blog-hero-img'>
      <div className="overlay"></div>
      <div className="hero-content">
        <h2 className='hero_heading'>BLOG</h2>
        <p className='hero_subheading'>Marketing Trends You Can<br/>Trust </p>
      </div>
    </div>
    </div>
  )
}

export default BlogHero